import { Questions } from '@/reactPages/Questions';
import NextWrapper from '@/components/layouts/Containers/NextWrapper/NextWrapper';

const meta = {
  title: 'Часто задаваемые вопросы - Сахалинское ипотечное агентство ',
  description:
    'Что такое кредитные каникулы? Кто имеет право на кредитные каникулы? Кто относится к членам семьи военнослужащих? Кредитные каникулы предоставляются автоматически? По каким ипотечным займам можно получить кредитные каникулы? На какой срок предоставляются кредитные каникулы?',
  keywords: 'Вопрос, ответ, вопрос ответ, Какой вопрос, Квартирный вопрос, Частые вопросы,',
};

const Page = () => {
  return (
    <>
      <NextWrapper meta={meta}></NextWrapper>
      <Questions></Questions>
    </>
  );
};

export default Page;
